export default ['JsonRPCService', (JsonRPCService) => {
    return {
        getClaimSummaries: (policyNumbersArray, query) => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'getClaimSummaries', [query, null]);
        },

        getClaimDetail: (claimNumber) => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'getClaimDetail', [claimNumber]);
        },

        getClaimPolicyDetail: (claimNumber) => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'getClaimPolicyDetail', [claimNumber]);
        },

        getClaimActivities: (claimNumber) => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'getClaimActivities', [claimNumber]);
        },

        updateClaimNote: (claimId, note) => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'updateClaimNote', [claimId, note]);
        },

        deleteClaimNote: (claimId, noteId) => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'deleteClaimNote', [claimId, noteId]);
        },

        createClaimNote: (claimNumber, noteDTO) => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'createClaimNote', [claimNumber, noteDTO]);
        },

        getClaimNotes: (claimNumber) => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'getClaimNotes', [claimNumber]);
        },


        // Gateway specific methods
        getClaimsForCurrentUser: (createdInLastXDays, queryOptions) => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'getClaimsForCurrentUser', [createdInLastXDays, queryOptions, [null]]);
        },

        getOpenClaimsForProducerCode: (createdInLastXDays, queryOptions, producerCode) => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'getOpenClaimsForProducerCode', [createdInLastXDays, queryOptions, producerCode]);
        },

        getClosedClaimsForCurrentUser: (createdInLastXDays, queryOptions) => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'getClosedClaimsForCurrentUser', [createdInLastXDays, queryOptions, [null]]);
        },

        getClosedClaimsForProducerCode: (createdInLastXDays, queryOptions, producerCode) => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'getClosedClaimsForProducerCode', [createdInLastXDays, queryOptions, producerCode]);
        },

        getRecentlyViewedClaims: () => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'getRecentlyViewedClaims', []);
        },

        addRecentlyViewedClaim: (claimNumber) => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'addRecentlyViewedClaim', [claimNumber]);
        },

        getClaimsForProducerCode: (createdInLastXDays, queryOptions, producerCode) => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'getClaimsForProducerCode', [createdInLastXDays, queryOptions, producerCode]);
        },

        getOpenClaimsForCurrentUser: (createdInLastXDays, queryOptions) => {
            return JsonRPCService.send('cc', 'gatewayclaim/claim', 'getOpenClaimsForCurrentUser', [createdInLastXDays, queryOptions, [null]]);
        },
        getClaimsForReport: (reportData) => {
             return JsonRPCService.send('cc', 'gatewayclaim/claim', 'getClaimsForReport', [reportData]);
        },
        getServiceQuoteInfo: (serviceQuoteId) => {
            return JsonRPCService.send('cc', 'gatewayfnol/fnol', 'getServiceQuoteData', [serviceQuoteId]);
        },
        saveServiceBoxDataForOpenClaim: (serviceQuoteId, claimNumber) => {
            return JsonRPCService.send('cc', 'gatewayfnol/fnol', 'saveServiceBoxDataForOpenClaim', [serviceQuoteId, claimNumber]);
        },
        disagreeQuoteFromServiceBox: (serviceQuoteId, claimNumber) => {
            return JsonRPCService.send('cc', 'gatewayfnol/fnol', 'disagreeQuoteFromServiceBox', [serviceQuoteId, claimNumber]);
        }
    };
}];